<div class="graph-wrapper" [style.height.px]="height">
  <ng-container *ngIf="!isLoadingData && signedUrl">
    <iframe [src]="signedUrl | safe" [style.height.px]="height"></iframe>
  </ng-container>
  <mat-progress-spinner *ngIf="isLoadingSpinner" mode="indeterminate"></mat-progress-spinner>
</div>